import PrintablePDFDocument from "./PrintablePDFDocument";

export default PrintablePDFDocument;
